export const APP_TITLE = 'Charity Portal';
export const PAGE_SIZE=7;
//export const BUSINESS_ID = '9ddff339-0a98-5aec-aba9-98c0644148cd' 
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
export const BUSINESS_MESSAGES_URL='/businesses/messages'
export const BUSINESS_USERS_URL ='/users'
export const BUSINESS_USER_EXISTS_URL ='/users/${userName}/checks/exists'
export const BUSINESS_SUBDOMAIN_EXISTS_URL ='/businesses/${domainId}/checks/exists'
export const BUSINESS_CONFIG_URL = "/businesses/config";
export const USER_EMAIL_ADDRESS_EXISTS="/users/emailaddress/${userEmailAddress}/checks/exists"
export const BUSINESS_REGISTRATION_URL="/businesses";
export const BUSINESS_REGISTRATION_RESET_PASSWORD_URL='/users/${userId}/password/actions/reset';
export const BUSINESS_REGISTRATION_STATE_URL='businesses/registration-state';
export const BUSINESS_REGISTRATION_EMAIL_VERIFY_URL = '/businesses/registration-state-transitions/email-verification-state';
export const BUSINESS_REPRESENTATIVES_FETCH_URL = '/businesses/representatives'
export const BUSINESS_VERIFICATION_DOCS_UPLOAD = '/businesses/verification-docs'
export const BUSINESS_REP_VERIFICATION_DOCS_UPLOAD = '/businesses/${rep_id}/verification-docs'
export const BUSINESS_DETAILS_DATA_ENTRY_URL='/businesses/registration-state-transitions/paymentgateway-verification-state';
export const BUSINESS_ACCOUNTS_URL='/accounts'
export const BUSINESS_ACCNT_BILLS_URL='/bills'
export const BUSINESS_ACCOUNT_TYPES_URL = '/businesses/accounttypes';
export const BUSINESS_DONATION_CAUSES = 'businesses/donationcauses';
export const BUSINESS_REPORT_PAYMENTS_BY_DONCAUSE='payments/reports/bydonationcausebydate'
export const BUSINESS_SPONSORS="businesses/sponsors";
export const BUSINESS_ADMIN_RESET_PASSWORD="/users/password/actions/adminreset";
export const SPONSORSHIPS_URL = '/donations/sponsorships';
export const BUSINESS_DONATION_BOXES_URL='/donations/donationboxes'
export const USER_REGISTRATION_URL = "/users/registrations";
export const USER_VERIFICATION_URL = "/users/userid/registration-state-transitions/email-verification-state";
export const LOGIN_URL = "/users/actions/auth/signin";
export const LOGOUT_URL = "/users/actions/auth/logout";
export const USER_PROFILE_URL = "/users/me";
export const MESSAGES_URL="/messages";
export const REFRESH_TOKEN_URL="/users/actions/auth/refreshtoken";
export const PROFILE_URL="/users/profile";
export const SETUP_PAYMENT_INTENTS_URL="/payments/setupintents";
export const PAYMENT_INTENTS_URL="/payments/bills/paymentintents";
export const NOLOGIN_PAYMENT_INTENTS_URL="/payments/nologin/paymentintents";
export const NOLOGIN_BILLPAYMENT_INTENTS_URL="/payments/nologin/billpaymentintents";
export const USER_PAYMENT_SOURCES_URL="/users/paymentsources";
export const USER_ACCOUNT_URL="/users/accounts";
export const USER_BILLS_FOR_ACCOUNT_URL="/bills/accounts";
export const USER_BILLS="/bills";
export const DONATION_URL="/donations";
export const DONATION_INTENTS_STATUS_UPDATE_URL="/payments/donations/paymentintents/status";
export const DONATION_INTENT_STATUS_URL="/payments/nologin/donation/paymentintents/status";
export const BILL_INTENT_STATUS_URL="/payments/bills/paymentintents/status";
export const DONATION_PAYMENTS="/payments/donation-payments";
export const PAYMENTS_HISTORY="/payments/history";
export const PAYMENTS_HISTORY_DOWNLOAD="/payments/history/download";
export const CURRENT_YEAR_STATEMENT_DOWNLOAD="/payments/history/curyearstatement/download";
export const PREV_YEAR_STATEMENT_DOWNLOAD="/payments/history/prvyearstatement/download";
export const BILL_PAYMENTS="/payments/bill-payments";
export const BUSINESS_DONATION_PAYMENTS="/payments/business/donation-payments";
export const BUSINESS_BILL_PAYMENTS="/payments/business/bill-payments";
export const BILL_PMT_RECPT_DOWNLOAD="/payments/bill-payments/receipts";
export const PAYMENT_RECPT_DOWNLOAD="/payments/receipts";
export const DONATION_PMT_RECPT_DOWNLOAD="/payments/donation-payments/receipts";
export const FORGOT_PASSWORD="/users/password/actions/forgot";
export const BUSINESS_DONATION_CAUSES_URL="/businesses/donationcauses";
export const ELAVON_TRANSACTION_TOKEN_URL="/elavon/trasnsaction-token";
export const PAYMENTINTENT_TOKEN_URL="/payments/paymentintent-token"
export const PAYMENTINTENT_TOKEN_STRIPE_URL="/payments/paymentintent-token-stripe"
export const PAYMENTINTENT_CARD_TOKEN_URL="payments/paymentcard-token";
export const RECURRINGPAYMENTS_URL="payments/recurring-payments";
export const RECURRINGPAYMENTS_ADMIN_URL="payments/recurring-payments-admin";
export const ONECLICKPAYMENTS_URL="payments/oneclick-payments";
export const USER_SPONSORSHIPS="users/sponsorships";

export const DASHBOARD_SPONSORSHIPS_COUNT= "businesses/dashboard/sponsorships-count";
export const DASHBOARD_YTD_PAYMENTS= "businesses/dashboard/ytd-payments";
export const DASHBOARD_SPONSORS_COUNT= "businesses/dashboard/sponsors-count";
export const DASHBOARD_REGUSERS_COUNT= "businesses/dashboard/registered-users-count";
export const DASHBOARD_PAST_PAYMENTS="businesses/dashboard/payments-for-past-months";
export const DASHBOARD_PAYMENTS_BY_DONATIONCAUSE="businesses/dashboard/payments-by-donationcause";
export const DASHBOARD_PAYMENTS_BY_DONATIONCAUSE_BY_MONTH="businesses/dashboard/payments-by-donationcause-month";
export const DASHBOARD_PAYMENTS_BY_DONATIONCAUSE_YTD="businesses/dashboard/payments-by-donationcause-ytd";

export const ADMIN_PAYMENT_CARDS="/payments/admin/paymentcards";
export const PAYMENT_CARDS="/payments/paymentcards";
export const BUSINESS_USER_ACCOUNTS_URL="/users/accounts/email";

export const BUSINESS_PROMOTIONS="/promotions";